<!-- your component HTML file -->
<div class="custom-dialog">
  <div class=row>
    <div class="col-md-11">
      <h1 mat-dialog-title>{{data.title}}</h1>
    </div>
    <div class="col-md-1 cross-icon">
      <i class="pi pi-times" (click)="onNoClick()"></i>
    </div>
  </div>
  <div mat-dialog-content>
    <p>{{data.message}}</p>
    <p>{{data.caption}}</p>
  </div>
  <div mat-dialog-actions align="end">
    <button *ngIf="data.close_btn !== ''" mat-raised-button color="primary" (click)="onNoClick()">{{data.close_btn}}</button>
    <button class="btn btn-solid" mat-raised-button color="primary" (click)="onSubmitClick()" cdkFocusInitial>{{data.submit_btn}}</button>
  </div>
</div>
